import Vue from 'vue';
import VueI18n from 'vue-i18n';
// import locale from 'element-ui/lib/locale'
// import enLocale from 'element-ui/lib/locale/lang/en'
// import zhLocale from 'element-ui/lib/locale/lang/zh-CN'

Vue.use(VueI18n);

const messages = {
	cn: require('@/system/language/cn.json'),
	en: require('@/system/language/en.json'),
	jp: require('@/system/language/jp.json'),
	zh_cn: require('@/system/language/cn.json'),
};

const i18n = new VueI18n({
	locale: 'cn',
	messages
});

// locale.i18n((key, value) => i18n.t(key, value))

export default i18n;